// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
/* tslint:disable */
import { Injectable } from '@angular/core';
import { GetMetricsRequest, GetMetricsResponse, QueryMetricsRequest, QueryMetricsResponse } from './objects/index';
import {
  GetMetricsRequestInterface,
  GetMetricsResponseInterface,
  QueryMetricsRequestInterface,
  QueryMetricsResponseInterface,
} from './interfaces/index';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HostService } from '../_generated/host.service';
import { Observable } from 'rxjs';
import { map, share } from 'rxjs/operators';

@Injectable()
export class AnalyticsApiService {
  constructor(private http: HttpClient, private hostService: HostService) {}

  getMetrics(r: GetMetricsRequest | GetMetricsRequestInterface): Observable<GetMetricsResponse> {
    const request = (<GetMetricsRequest>r).toApiJson ? <GetMetricsRequest>r : new GetMetricsRequest(r);
    return this.http
      .post<GetMetricsResponseInterface>(
        this.hostService.hostWithScheme() + '/multilocationanalytics.v1.AnalyticsService/GetMetrics',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => GetMetricsResponse.fromProto(resp)),
        share(),
      );
  }

  queryMetrics(r: QueryMetricsRequest | QueryMetricsRequestInterface): Observable<QueryMetricsResponse> {
    const request = (<QueryMetricsRequest>r).toApiJson ? <QueryMetricsRequest>r : new QueryMetricsRequest(r);
    return this.http
      .post<QueryMetricsResponseInterface>(
        this.hostService.hostWithScheme() + '/multilocationanalytics.v1.AnalyticsService/QueryMetrics',
        request.toApiJson(),
        this.apiOptions(),
      )
      .pipe(
        map((resp) => QueryMetricsResponse.fromProto(resp)),
        share(),
      );
  }

  private apiOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
  }
}
